import { getDeliveryApiBase } from "./deliveryApi";
import { getAdminToken } from "./adminAuth";

export const FEEDBACK_DEFAULT_PAGE_SIZE = 20;
export const FEEDBACK_MAX_PAGE_SIZE = 50;

function apiBase() {
    const base = getDeliveryApiBase();
    if (!base) {
        throw new Error("MISSING_API");
    }
    return base;
}

async function requestJson(path, { method = "GET", body } = {}) {
    const token = getAdminToken();
    const response = await fetch(`${apiBase()}${path}`, {
        method,
        headers: {
            ...(body ? { "Content-Type": "application/json" } : {}),
            Authorization: `Bearer ${token}`,
        },
        body: body ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        const error = new Error(payload.error?.message || "REQUEST_FAILED");
        error.status = response.status;
        throw error;
    }
    return response.json().catch(() => ({}));
}

function buildFeedbacksQuery({
    sourceType,
    albumPath,
    q,
    from,
    to,
    page = 1,
    pageSize = FEEDBACK_DEFAULT_PAGE_SIZE,
} = {}) {
    const params = new URLSearchParams();
    if (sourceType) {
        params.set("sourceType", sourceType);
    }
    if (albumPath) {
        params.set("albumPath", albumPath);
    }
    if (q) {
        params.set("q", q);
    }
    if (from != null) {
        params.set("from", String(from));
    }
    if (to != null) {
        params.set("to", String(to));
    }
    params.set("page", String(page));
    params.set("pageSize", String(pageSize));
    return params.toString();
}

export async function listFeedbacks(options = {}) {
    const query = buildFeedbacksQuery(options);
    return requestJson(`/api/feedbacks?${query}`);
}

export async function deleteFeedback(id) {
    return requestJson(`/api/feedbacks/${encodeURIComponent(id)}`, { method: "DELETE" });
}
